import * as React from "react";
import AppBody from "../../../components/AppBody";
import Button from "../../../components/connect-ui/Button";
import Container from "../../../components/connect-ui/Container";
import Header from "../../../components/Header";
import RouteHeaderLogo from "../../../components/RouteHeaderLogo";
import { USER_INTENT } from "../../../lib/constants";
import useCloseClickHandler from "../../../hooks/useCloseClickHandler";
import useHandleBackClick from "../../../hooks/useHandleBackClick";
export default function BaseUnsupportedIssuerRoute(_a) {
    var issuer = _a.issuer;
    var closeClickHandler = useCloseClickHandler();
    var handleBack = useHandleBackClick();
    function handleCloseClick() {
        closeClickHandler({ userIntent: USER_INTENT.PROCEED_MANUALLY });
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(Header, null,
            React.createElement(RouteHeaderLogo, null)),
        React.createElement(AppBody, null,
            React.createElement(Container, { className: "grow" },
                React.createElement("div", { className: "flex flex-grow flex-col justify-center" },
                    React.createElement("h2", { "data-cy": "title", className: "mb-4 text-2xl font-bold" },
                        "Policy retrieval from ",
                        (issuer === null || issuer === void 0 ? void 0 : issuer.name) || "selected issuer",
                        " is not available"),
                    React.createElement("p", { "data-cy": "content", className: "mb-4 text-base font-semibold text-black-300" }, "Please continue to enter your information manually or select a different issuer."),
                    React.createElement("div", { className: "space-y-2" },
                        React.createElement(Button, { "data-cy": "close", onClick: handleCloseClick }, "Continue"),
                        React.createElement(Button, { variant: "outlined", "data-cy": "back", onClick: handleBack }, "Back to issuer selection")))))));
}
